import { LS_TOKEN_KEY } from '@/constants'

export function getToken () {
  return sessionStorage.getItem(LS_TOKEN_KEY)
}
